import Route from '@ember/routing/route'
import { task, timeout } from 'ember-concurrency'
import { Product } from 'teacher-ui-client/utils/products'
import type { Precinct } from 'teacher-ui-client/utils/precincts'
import { defaultPrecinctForProduct, isValidPrecinctForProduct, isPrecinct } from 'teacher-ui-client/utils/precincts'
import { service } from '@ember/service'
import type ContentfulClient from 'teacher-ui-client/services/contentful-client'
import type { Params } from 'teacher-ui-client/subscription-type/lessons/route'

export default class ReadingEggsLessonsRoute extends Route {
  @service contentfulClient!: ContentfulClient

  model() {
    const lessonsParams = this.paramsFor('subscription-type.lessons') as Params
    const { pageNumber, searchQuery } = lessonsParams

    const precinct =
      isPrecinct(lessonsParams.precinct) && isValidPrecinctForProduct(Product.RE, lessonsParams.precinct)
        ? lessonsParams.precinct
        : defaultPrecinctForProduct(Product.RE)

    return {
      loaderInstance: this.fetchEntries.perform({
        pageNumber,
        searchQuery,
        precinct,
      }),
    }
  }

  fetchEntries = task(
    { restartable: true },
    async ({ pageNumber, searchQuery, precinct }: { pageNumber: number; searchQuery?: string; precinct: Precinct }) => {
      await timeout(500)

      /**
       * 10 lessons + 1 quiz per map. This way, the default pager when no filtering is applied represents maps.
       */
      const perPage = 11

      const lessonsData = await this.contentfulClient.getPrecinctLessonsDataMapOrdered(precinct, {
        pageNumber,
        perPage,
        searchQuery,
      })
      const { previewByLessonDataId, resourcesByLessonDataId } =
        await this.contentfulClient.getLessonsDataRelatedEntries(lessonsData)

      const pageCount = Math.ceil(lessonsData.total / perPage)

      return { lessonsData, previewByLessonDataId, resourcesByLessonDataId, pageCount }
    },
  )
}
